import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { CountrySwitcherComponent } from './country-switcher.component';

@NgModule({
    imports: [CommonModule, FormsModule, TranslateModule, LocalizeRouterModule],
    declarations: [CountrySwitcherComponent],
    exports: [CountrySwitcherComponent]
})
export class CountrySwitcherModule {}
